import { addStyles } from 'ethcss'
import { IStyles, mediaCSS, colors } from 'theme'

const broadcastEvents: IStyles = {
    eventModal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
    },
    eventModalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        borderRadius: 20,
        minWidth: 560,
        maxWidth: 560,
        padding: 30,
    },
    eventModalTitle: {
        fontSize: 22,
    },

    deleteConfirmWrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    deleteConfirm: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '340px',
        transform: 'translate(-50%, -50%)',
        background: colors.white,
        textAlign: 'center',
        padding: 34,
        borderRadius: 20,
    },
    controls: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '30px auto 0 auto',
        maxWidth: 210,
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        width: 100,
    },
    fieldWrapper: {
        marginTop: 20,
    },
    label: {
        marginBottom: 10,
    },
    selectJson: {
        textAlign: 'center',
        border: `1px dashed ${colors.grey}`,
        borderRadius: 5,
        padding: 30,
    },
    createButton: {
        marginTop: 20,

        [mediaCSS.tabMini]: {
            marginTop: 46,
        },
    },
    buttons: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    deleteInfoWrapper: {
        textAlign: 'center',
    },
    eventModalText: {
        marginTop: 14,
    },
    buttonWrapper: {
        marginTop: 20,
    },
    infoFieldWrapper: {
        marginTop: 10,
    },
    eventLabel: {
        fontWeight: 700,
    },
    control: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 30,
    },
    tabs: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 30,

        [mediaCSS.tabMini]: {
            marginTop: 50,
        },
    },
    tab: {
        display: 'flex',
        padding: 20,
        justifyContent: 'center',
        width: '49.5%',
        border: `1px solid ${colors.greyBorder}`,
        borderRadius: 7,
        cursor: 'pointer',
        transition: 'all 0.3s',

        '&:hover': {
            backgroundColor: colors.greyBorder,
        },
    },
    activeTab: {
        backgroundColor: colors.greyBorder,
    },
    jsonBlockWrapper: {
        position: 'relative',
    },
    fileInput: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        opacity: 0,
    },
    jsonContainer: {
        maxHeight: 260,
        overflow: 'auto',
    },
    settingsLink: {
        textDecoration: 'underline',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
    eventValue: {
        marginTop: 6,
    },
    copyToClipboard: {
        width: 24,
        margin: '14px 0',
    },
    eventTitle: {
        textAlign: 'center',
        fontSize: 16,
        lineHeight: 1.4,
    },
}

addStyles(broadcastEvents)
export default broadcastEvents
